import axios from "axios";
export const baseURL = "https://portal.mindzcube.com/api";
//export const baseURL = "http://localhost/programs/mindzcube/api";
const api = axios.create({ baseURL: baseURL });

export default api;
